export default __webpack_public_path__ + "static/media/T340_RoHS.7603b82d.pdf";